import { CSSProperties } from 'react'

export const tableStyles: Record<string, CSSProperties> = {
  container: {
    overflowY: 'auto',
    height: '100%',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  header: {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #ddd',
  },
  headerCell: {
    padding: '10px',
    textAlign: 'left',
  },
  headerCellCenter: {
    padding: '10px',
    textAlign: 'center',
  },
  row: {
    borderBottom: '1px solid #eee',
  },
  cell: {
    padding: '10px',
    fontWeight: 500,
  },
  cellMuted: {
    padding: '10px',
    color: '#999',
    fontWeight: 500,
  },
  cellNormal: {
    padding: '10px',
    color: '#333',
    fontWeight: 500,
  },
  confidenceCell: {
    padding: '10px',
    textAlign: 'center',
  },
  requiredMarker: {
    color: '#e74c3c',
    marginLeft: '4px',
  },
}
